import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Primitives";

export const buildFaqs = (s) => [
  ["Yeni Mercan Restoran nerede?", `Yeni Mercan Restoran, ${s.address || "Buca, İzmir"} adresinde hizmet veriyor. Konum için sayfadaki haritayı kullanabilir veya ${s.phone} numarasından bize ulaşabilirsiniz.`],
  ["Restoranınız kaçta açılıyor, kaçta kapanıyor?", `${s.hours || "7 gün 24 saat açığız"}. Sabah kahvaltısından gece çorbasına kadar günün her saati sıcak servis yapıyoruz.`],
  ["Buca'da ev yemekleri yiyebileceğim bir yer arıyorum, menünüzde neler var?", "Her gün taze hazırlanan kuru fasulye, et sote, tas kebabı, musakka gibi tencere yemeklerinin yanında mercimek, işkembe ve kelle paça çorbaları, serpme kahvaltı, kokoreç ve premium ızgaralar sunuyoruz."],
  ["Nasıl rezervasyon yapabilirim?", `Web sitemizdeki online rezervasyon formunu doldurabilir, ${s.phone} numarasını arayabilir veya WhatsApp üzerinden yazabilirsiniz. Talebiniz telefonla teyit edildikten sonra kesinleşir.`],
  ["Gece geç saatte çorba ve kokoreç bulabilir miyim?", "Evet. Yeni Mercan 7/24 açık olduğu için gece geç saatlerde de işkembe, kelle paça, mercimek çorbası ve odun ateşinde kokoreç servis ediyoruz."],
  ["Menünüze ve fiyatlarınıza nereden bakabilirim?", "Güncel menümüz ve KDV dahil fiyatlarımız web sitemizdeki Dijital Menü sayfasında yer alır. Restoranda masalardaki QR kodu okutarak da menüye ulaşabilirsiniz."],
];

export function FAQ({ faqs }) {
  return (
    <section className="bg-[#F3EDE2] py-24 sm:py-28" data-testid="faq-section" aria-labelledby="faq-title">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow !text-[#9E7B27]">Sıkça Sorulanlar</p>
          <h2 id="faq-title" className="mt-4 font-serif-ym text-4xl sm:text-5xl font-semibold text-[#1A1513] leading-[1.05]">
            Buca'da 7/24 açık restoran hakkında merak edilenler
          </h2>
        </Reveal>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="divide-y divide-[#E5DCD0] border-y border-[#E5DCD0]">
            {faqs.map(([q, a], i) => (
              <AccordionItem key={q} value={`f${i}`} className="border-0">
                <AccordionTrigger className="py-6 text-left font-serif-ym text-xl text-[#1A1513] hover:no-underline [&>svg]:hidden" data-testid={`faq-question-${i}`}>
                  <span className="pr-6">{q}</span>
                  <Plus size={18} className="shrink-0 text-[#9E7B27] transition-transform duration-300 [[data-state=open]_&]:rotate-45" />
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[#6B5E56] leading-relaxed text-base" data-testid={`faq-answer-${i}`}>{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
